import { Skeleton } from '@monksflow/monks-ui';
import { useTranslation } from 'react-i18next';
/**
 * `BriefDetailLoading` — placeholder UI rendered while the brief query is
 * pending. Skeleton blocks mirror the eventual layout (header strip,
 * fields panel, two section blocks) to minimise visual jump on resolve.
 */
const SKELETON_ROW_COUNT = 4;

export function BriefDetailLoading() {
  const { t } = useTranslation('projects');

  return (
    <div
      role="status"
      aria-label={t('projectBriefDetail.briefDetailLoading.loadingBrief')}
      data-testid="brief-detail-loading"
      aria-busy="true"
      className="flex flex-col gap-4 p-4"
    >
      {/* Header strip */}
      <Skeleton data-testid="brief-detail-loading-skeleton" className="h-8 w-2/3" />
      {/* Body skeleton blocks */}
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
        <Skeleton key={index} data-testid="brief-detail-loading-skeleton" className="h-4 w-full" />
      ))}
    </div>
  );
}
